import uuid from 'uuid/v1';

export const header = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};

export const authHeader = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('user.jwt')
};

let ApiUtils = {
    checkStatus: function(response) {
        if (response.status >= 200 && response.status <= 299) {
            return response;
        } else {
            return response.text().then(message => {
                let error = new Error(JSON.stringify({ message: message, statusCode: response.status }));
                throw error;
            });
        }

    },

    getUUID: function() {

        return uuid();
    },
    getAuthHeader: function authHeader() {
        // return authorization header with jwt token
        let user = JSON.parse(localStorage.getItem('user'));

        if (user && user.token) {
            return { 'Authorization': 'Bearer ' + user.token };
        } else {
            return {};
        }
    }

};
export { ApiUtils as default };



// WEBPACK FOOTER //
// ./src/utils/apiutils.js